/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import HomePageLayout from 'global/HomePageLayout';
import SEO from 'global/SEO';
import Image from 'global/Image';
import { useEffect, useState } from 'react';
import {
  Container,
  Title,
  FAQContainer,
  DownloadSection,
  DownloadSectionLeft,
  SystemRequirementWrapper,
} from './styled';
import {
  faq,
  schemaJson,
  keyword,
  metaDesc,
  metaTitle,
  systemRequirement,
} from './constants';
import DownloadButtons from './DownloadButtons';
import Accordion from './Accordion';
import DownloadHero from './Hero';
import MultiMonitor from './MultiMonitor';
import CustomLayout from './CustomLayout';
// TEMPORARY HIDDEN CONTENT IS NOT YET AVAILABLE
// import MobileAdvanced from './MobileAdvanced';
// import Advanced from './AdvancedOrderbook';
import { DesktopAppDownloadAnalytics } from './desktop-analytics';
import ShareYourSetup from './ShareYourSetup';

const DownloadPage = () => {
  useEffect(() => {
    // need time to get clevertap id to send event
    setTimeout(() => {
      DesktopAppDownloadAnalytics.onDesktopAppLandingPage();
    }, 300);
  }, []);
  const [openTab, setOpenTab] = useState<'windows' | 'mac'>('windows');

  return (
    <HomePageLayout theme="dark" hideStartInvesting>
      <SEO
        description={metaDesc}
        title={metaTitle}
        schemaJson={schemaJson}
        keywords={keyword}
      />

      <Container style={{ position: 'relative' }}>
        <DownloadHero />
        <MultiMonitor />

        <CustomLayout />

        {/* TEMPORARY HIDE UNTIL READY */}
        {/* <Advanced />
          <div className="separator-wrapper">
            <div className="separator"></div>
          </div>
          <MobileAdvanced /> */}
        {/* TEMPORARY HIDE UNTIL READY */}

        <ShareYourSetup />

        {/* REMOVE WHEN ADVANCED IS READY */}
        <div className="separator-wrapper">
          <div className="separator" />
        </div>
        {/* REMOVE WHEN ADVANCED IS READY */}

        <div className="fade" />

        <FAQContainer>
          <Title>
            <span className="green">Frequently</span> Asked Question
          </Title>

          <Accordion content={faq} />
        </FAQContainer>

        <DownloadSection>
          <DownloadSectionLeft>
            <Title>
              Stockbit <span className="green">Desktop App</span> Bisa Diakses
              untuk Mac dan Windows
            </Title>
            <DownloadButtons source="Download Page" />
          </DownloadSectionLeft>
          <div className="divider" />
          <SystemRequirementWrapper>
            <span className="title">Recommended Requirements</span>
            <div className="tabs">
              <div
                onClick={() => setOpenTab('windows')}
                className={`${openTab === 'windows' && 'active'} tab-head`}
                role="button"
              >
                Windows
              </div>
              <div
                onClick={() => setOpenTab('mac')}
                className={`${openTab === 'mac' && 'active'} tab-head`}
                role="button"
              >
                MacOS
              </div>
            </div>
            <div className="tab-content">
              {systemRequirement[openTab].map((x, index) => (
                <div className="tab-content-item" key={`system-${index + 1}`}>
                  <span className="key">{x.key}:</span>
                  <span>{x.value}</span>
                </div>
              ))}
            </div>
          </SystemRequirementWrapper>
        </DownloadSection>
      </Container>
    </HomePageLayout>
  );
};

export default DownloadPage;
